import { useTranslation } from "react-i18next";

import { OnOffBadge } from "@/components/setup/on-off-badge";
import { getTimelineIcon } from "@/lib/timeline-icons";
import type { TimelineConfig } from "@/lib/types";

const MAX_VISIBLE_EVENTS = 4;

export function TimelinePreviewCard({
  timeline,
  on,
}: {
  timeline: TimelineConfig | undefined;
  on: boolean;
}) {
  const { t } = useTranslation();
  const events = (timeline?.days ?? []).flatMap((d) => d.events);

  return (
    <div className="space-y-3 bg-card p-4">
      <div className="flex items-center justify-between">
        <p className="font-medium">{t("setup.preview.timelineTitle")}</p>
        <OnOffBadge on={on} />
      </div>
      {events.length > 0 ? (
        <>
          <ul className="space-y-1.5">
            {events.slice(0, MAX_VISIBLE_EVENTS).map((e) => {
              const Icon = getTimelineIcon(e.icon);
              return (
                <li key={e.id} className="flex items-center gap-2 text-sm">
                  <Icon className="h-3.5 w-3.5 shrink-0 text-muted-foreground" />
                  <span className="w-12 shrink-0 font-mono text-xs text-muted-foreground">
                    {e.time}
                  </span>
                  <span className="truncate">{e.name || t("setup.preview.untitledEvent")}</span>
                </li>
              );
            })}
          </ul>
          {events.length > MAX_VISIBLE_EVENTS && (
            <p className="text-xs text-muted-foreground">
              {t("setup.preview.moreEvents", { count: events.length - MAX_VISIBLE_EVENTS })}
            </p>
          )}
        </>
      ) : (
        <p className="text-sm text-muted-foreground">{t("setup.preview.noEvents")}</p>
      )}
    </div>
  );
}
